export const liveCompanyRedirects = Object.freeze({
  redirectMap: new Map([
    ['welcome', { from: 'welcome', to: 'dashboard' }],
    ['onboarding', { from: 'onboarding', to: 'candidates' }],
  ]),
})

export const dormantCompanyRedirects = Object.freeze({
  redirectMap: new Map([
    ['dashboard', { from: 'dashboard', to: 'candidates' }],
    ['welcome', { from: 'welcome', to: 'candidates' }],
    ['shortlist', { from: 'shortlist', to: 'candidates' }],
  ]),
})

export const preLiveCompanyRedirects = Object.freeze({
  redirectMap: new Map([
    ['dashboard', { from: 'dashboard', to: 'welcome' }],
    ['shortlist', { from: 'shortlist', to: 'welcome' }],
    ['interview_requests', { from: 'interview_requests', to: 'welcome' }],
    ['analytics', { from: 'analytics', to: 'welcome' }],
    ['candidates', { from: 'candidates', to: 'welcome' }],
    ['onboarding', { from: 'onboarding', to: 'welcome' }],
    ['applications', { from: 'onboarding', to: 'welcome' }],
  ]),
})

export const defaultCompanyRedirects = Object.freeze({
  redirectMap: new Map([
    ['dashboard', { from: 'dashboard', to: 'candidates' }],
    ['welcome', { from: 'welcome', to: 'candidates' }],
    ['shortlist', { from: 'shortlist', to: 'candidates' }],
    ['positions', { from: 'positions', to: 'candidates' }],
    ['interview_requests', { from: 'interview_requests', to: 'candidates' }],
    ['analytics', { from: 'analytics', to: 'candidates' }],
  ]),
})

export const companyStateRedirects = ({ companyState, acceptedTerms }) => {
  switch (companyState) {
    case 'live':
      if (!acceptedTerms) {
        const liveCompanyUnacceptedTermsRedirects = {
          redirectMap: new Map([
            ['dashboard', { from: 'dashboard', to: 'candidates' }],
            ['welcome', { from: 'welcome', to: 'candidates' }],
            ['applications', { from: 'applications', to: 'candidates' }],
          ]),
        }
        return liveCompanyUnacceptedTermsRedirects
      }
      return liveCompanyRedirects

    case 'dormant':
      return dormantCompanyRedirects

    // All company pre-live states have the same redirects
    case 'onboarding':
    case 'onboarding_completed':
    case 'setup_call':
    case 'setup_meeting':
    case 'call_scheduled':
    case 'completing_profile':
    case 'ready_to_go_live':
    case 'accepting_terms':
      return preLiveCompanyRedirects

    case 'rejected':
    case 'junk_data':
    case 'unresponsive':
    default:
      return defaultCompanyRedirects
  }
}
